export default "/images/thumbs-down.svg?8cb75e3f948a06c4fd4ee1eab977ef86";